import { useTranslation } from "react-i18next";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { StepInstallationFormData, StepPersonFormData } from "../../../types/stepsFormData";
import { ContractationTypes } from "../../../types/contractation";
import { FormInstallationSchema } from "../schema/FormInstallationSchema";
import useContractation from "../../../hooks/useContractation";

type ContractationFormState = {
  leadsConsent: boolean;
};

type UseFormInstallationOptions = {
  type: ContractationTypes;
  installationStep: StepInstallationFormData;
  personStep: StepPersonFormData;
  contractation: ContractationFormState;
  comerOriginEnabled: boolean;
};

export const useFormInstallation = ({
  type,
  installationStep,
  personStep,
  contractation,
  comerOriginEnabled,
}: UseFormInstallationOptions) => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();
  const { personFirstFlow } = useContractation();
  const showChangeOwner = personFirstFlow;
  const showInvoicingAddress = personFirstFlow;
  const showLeadConsent = !personFirstFlow;

  const validationSchema = FormInstallationSchema({
    settings: Settings,
    type,
    showChangeOwner,
    showInvoicingAddress,
    showLeadConsent,
    comerOriginEnabled,
  });

  const defaultValues: StepInstallationFormData = {
    ...installationStep,
    leadsConsent: contractation.leadsConsent,
    changeOwner: personStep.changeOwner,
  };

  return {
    defaultValues,
    validationSchema,
    showChangeOwner,
    showInvoicingAddress,
    showLeadConsent,
    t,
  };
};
